<template lang="pug">
    .z-big-date(ref="parent" v-bind:class="{'focus': focus, 'no-label' : ($props.label ? false : true), 'has-value': $props.value, 'has-error': error && error.length, 'disabled': $props.disabled, 'readonly': $props.readonly}")
        .z-big-date-container(v-on:click="onInputClick" v-bind:class="{'active': focus}")
            .icon(v-html="$props.icon")
            .z-big-date-input
                slot
            //.z-big-date__arrow
                i.fas.fa-chevron-down
            datetime(
                ref="input"
                v-model="val"
                v-bind:id="$props.id"
                v-bind:name="$props.name"
                v-bind:required="$props.required"
                v-bind:disabled="$props.disabled"
                v-bind:readonly="$props.readonly"
                v-bind:placeholder="$props.label"
                
                type="date" 
                v-bind:use12-hour="false"
                v-bind:week-start="1" 
                v-bind:phrases="{ ok: 'Ок', cancel: 'Отмена' }"
            )
        span.z-error(v-if="error") {{error}}
</template>
<script>
    export default {
        name: 'z-big-date',
        components: {},
        props: {
            id: {
                type: String,
                default: 'z-input-date'
            },
            name: {
                type: String,
                default: 'z-input-date'
            },
            label: {
                type: String,
                default: ''
            },
            placeholder: {
                type: String,
                default: ''
            },
            required: {
                type: Boolean,
                default: false
            },
            readonly: {
                type: Boolean,
                default: false
            },
            loading: {
                type: Boolean,
                default: false
            },
            disabled: {
                type: Boolean,
                default: false
            },
            error: {
                type: String,
                default: ''
            },
            value: {
                type: [String, Number, Boolean],
                default: () => ''
            },
            icon: {
                type: String,
                default: '<i class="far fa-calendar-alt"></i>'
            },
        },
        data() {
            return {
                focus: false,
                val: null,
                displayLabel: null,
            }
        },
        created() {
            if (this.$props.value) {
                this.val = this.$props.value;
                this.setLabel();
            }
        },
        mounted() {
            if (this.$props.value) {
                this.val = this.$props.value;
                this.setLabel();
            }
        },
        watch: {
            'value'(value, old) {
                if (this.val != value) {
                    this.val = value;
                    this.setLabel();
                }
            },
            'val'(val) {
                this.displayLabel = val;
                this.$emit('input', val);
                this.onBlur();
            }
        },
        computed: {},
        methods: {
            listeners() {
                this.blurListener = document.addEventListener('click', e => {
                    if (this.$refs && this.$refs.parent && !this.$refs.parent.contains(e.target)) this.onBlur();
                });
            },
            setLabel() {
                if (this.$children) {
                    this.displayLabel = null;
                    this.$children.map(item => {
                        if (item.value == this.val) {
                            this.displayLabel = item.label;
                        }
                    });
                }
            },
            onFocus(e) {
                if (!e.target.getAttribute('data-isitem')) {
                    if (this.focus) this.onBlur();
                    else {
                        if (this.$props.disabled) return;
                        this.listeners();
                        this.focus = true;
                        this.$emit('focus');
                    }
                }
            },
            onBlur() {
                document.removeEventListener('click', this.blurListener, false);
                this.focus = false;
                this.$emit('blur');
            },
            onInputClick(e) {
                //onFocus
                //this.$refs.input.open(e);
                //let datetimeComponent = this.$refs.input.$el;
                //let input = datetimeComponent.querySelector('input');
                //input.focus();
                //input.click();
            }
        }
    }
</script>
<style lang="sass">
    .z-big-date
        margin: 4px 0 10px 0
        position: relative
        &.disabled
            .z-big-date-container
                background: #eee
            .z-big-date__arrow
                display: none
        .z-big-date-container
            display: flex
            align-items: center
            justify-content: flex-start
            height: 50px
            background: #FFFFFF
            box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.2)
            border-radius: 3px
            padding: 10px
            position: relative
            .icon
                font-size: 22px
                width: 24px
                height: 22px
                color: #000
                margin: 0 10px 0 0
                position: relative
                z-index: 25
                svg
                    width: 24px
            .z-big-date-input
                display: none
            &.active
                .z-big-date-input
                    display: block
        .z-error
            display: block
            height: auto
            min-height: 15px
            font-size: 11px
            line-height: 11px
            padding-top: 4px
            color: #ff1744
        label
        .vdatetime
            position: initial
            z-index: 20
        input
            font-size: 14px
            line-height: 24px
            border: none
            background: transparent
            outline: none
            color: #000
            font-weight: 400
            border-radius: 3px
            padding: 0 10px 0 44px
            width: 100%
            height: 100%
            position: absolute
            z-index: 10
            top: 0
            left: 0
            cursor: default
            -webkit-appearance: none !important
        .error
        .z-big-date-input
            position: absolute
            top: 40px
            padding: 10px 0
            width: 100%
            left: 0
            right: 0
            z-index: 101
            background: #FFFFFF
            box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25)
            border-radius: 3px
            border-top-left-radius: 0
            border-top-right-radius: 0
        .z-big-date__arrow
            position: absolute
            z-index: 25
            right: 10px
            font-size: 16px
            width: 20px
            height: 20px
            display: flex
            align-items: center
            justify-content: center
    .z-big-date.has-error
        label   
            color: #ff1744
        .z-big-date-container
            &::after
                background-color: #ff1744
            &::before
                background-color: #ff1744
    .z-big-date.focus
        label
        .z-big-date-container
            &::after
                
            &::before
                
    .z-big-date.disabled
        select
            background: #eaeaea
    .z-big-date.readonly
        select
            background: #eaeaea                
</style>


// WEBPACK FOOTER //
// ZBigDate.vue?526b0212